import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import Layout from '../../../app/Layout.tsx';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';

export const createFolioNavItems = (useReconciliationDashboard: boolean): RouteItem => ({
  text: 'Folio',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.folio, ApplicationRoles.reservations],
  layout: <Layout />,
  subItems: [
    {
      text: 'Folio Table',
      path: applicationRoutes.agent.folioTableNew,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.folio, ApplicationRoles.reservations],
      async lazy() {
        const component = await import('../../../features/folio/Folio');
        return { Component: component.default };
      }
    },
    {
      text: 'Folio Requests',
      path: applicationRoutes.agent.folioRequests,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.folio, ApplicationRoles.reservations],
      async lazy() {
        const component = await import('../../../features/folioRequests/FolioRequestsPage.tsx');
        return { Component: component.FolioRequestsPage };
      }
    },
    ...(useReconciliationDashboard
      ? [
          {
            text: 'Reconciliations',
            path: applicationRoutes.agent.reconciliationDashboard,
            authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
            allowedRoles: [ApplicationRoles.folio, ApplicationRoles.reservations],
            async lazy() {
              const component =
                await import('../../../features/reconciliationDashboard/ReconciliationDashboardPage.tsx');
              return { Component: component.ReconciliationDashboardPage };
            }
          } satisfies RouteItem
        ]
      : [])
  ]
});
